import {TrackItem} from "../types";
import {Glue42Office} from "../../../glue4office";

export class TrackItemDictionary implements TrackItem {
    private items: { [key: string]: Glue42Office.Outlook.T42Id[] } = {};

    public containsIds(ids: Glue42Office.Outlook.T42Id[]): boolean {
        const key = this.getOutlookId(ids);
        return this.items.hasOwnProperty(key);
    }

    public add(emailIds: Glue42Office.Outlook.T42Id[], ids: Glue42Office.Outlook.T42Id[]): void {
        const key = this.getOutlookId(emailIds);
        this.items[key] = ids;
    }

    public remove(ids: Glue42Office.Outlook.T42Id[]): void {
        const key = this.getOutlookId(ids);
        delete this.items[key];
    }

    public get(ids: Glue42Office.Outlook.T42Id[]): Glue42Office.Outlook.T42Id[] {
        const key = this.getOutlookId(ids);
        return this.items[key];
    }

    private getOutlookId(ids: Glue42Office.Outlook.T42Id[]): string {
        return ids.filter((id) => id.systemName.indexOf("Outlook") === 0)[0].nativeId;
    }
}

export default new TrackItemDictionary();
